import { useMutation, useQueryClient } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { BaseOption, InputSize, Select } from "shared/components";
import { Avatar } from "shared/components/Avatar";

type StageOptions = { color: string } & BaseOption;

interface StageSelectProps {
  value?: number;
  rowId?: string;
  options: StageOptions[];
}

export const StageSelect = ({ value, rowId, options }: StageSelectProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationKey: ["LEAD_CHANGE_STAGE"],
    mutationFn: ({
      lead_id,
      stage_id
    }: {
      lead_id: string;
      stage_id: number;
    }) =>
      instance.post("/portal/v1/leads/bulk_change_stage", {
        lead_ids: [Number(lead_id)],
        stage_id
      }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
    }
  });

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Select
        menuPortalTarget={document.body}
        menuPosition="fixed"
        className="!rounded-lg max-w-[210px]"
        size={InputSize.SM}
        id={`assigned-to-select-${rowId}`}
        value={value || "-"}
        options={options}
        onChange={(e) => {
          mutateAsync({
            lead_id: String(rowId),
            stage_id: Number(e.target.value)
          });
        }}
        placeholder="Unassigned"
        formatOptionLabel={(option) => {
          const stageOption = option as StageOptions;
          return (
            <div className="flex items-center gap-2 py-1">
              <Avatar
                fallbackText=""
                fallbackBackgroundColor={stageOption.color}
              />
              <span>{stageOption.label}</span>
            </div>
          );
        }}
      />
    </div>
  );
};
